import React, { useCallback, useEffect, useState } from 'react';
import { ActivityIndicator, StatusBar, StyleSheet, View } from 'react-native';
import Pdf from 'utils/packages/pdf';
import ReactNativeBlobUtil from 'utils/packages/bloblUtil';
import { Button, Spacer } from 'design-system';
import { useHeaderHeight } from 'hooks';
import Modal from 'utils/packages/Modal';
import BottomPanel from 'design-system/BottomPanel';
const strings = {
    defaultButtonTitle: 'Done',
};
const renderActivityIndicator = () => <ActivityIndicator />;
const { dirs } = ReactNativeBlobUtil.fs;
const PdfScreen = ({ navigation, route }) => {
    const uri = route.params.url;
    const buttonTitle = route.params.buttonTitle || strings.defaultButtonTitle;
    const { withTopPadding } = route.params;
    const [downloading, setDownloading] = useState(false);
    const { fileName } = route.params;
    const headerHeight = useHeaderHeight();
    useEffect(() => () => {
        route.params.onClose?.();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const handleDownload = useCallback(() => {
        if (downloading)
            return;
        setDownloading(true);
        ReactNativeBlobUtil.config({
            fileCache: true,
            appendExt: 'pdf',
            addAndroidDownloads: {
                path: `${dirs.DownloadDir}/${fileName}.pdf`,
                useDownloadManager: true,
                notification: true,
                title: fileName,
                mime: 'application/pdf',
                mediaScannable: true,
            },
        })
            .fetch('GET', uri)
            .then((res) => {
            ReactNativeBlobUtil.android.actionViewIntent(res.path(), 'application/pdf');
        })
            .catch(() => {
            Modal.showError('Something went wrong');
        })
            .finally(() => {
            setDownloading(false);
        });
    }, [downloading, fileName, uri]);
    return (<View style={styles.container}>
      <StatusBar barStyle="dark-content" animated/>
      <View style={styles.container}>
        <Pdf source={{ uri, cache: true }} style={[
            styles.container,
            withTopPadding && { paddingTop: headerHeight },
        ]} renderActivityIndicator={renderActivityIndicator} trustAllCerts={false}/>
      </View>
      <BottomPanel>
        {!!fileName && (<>
            <Button brandReversed title="Download" loading={downloading} onPress={handleDownload}/>
            <Spacer h={8}/>
          </>)}
        <Button brand title={buttonTitle} onPress={navigation.goBack}/>
      </BottomPanel>
    </View>);
};
const styles = StyleSheet.create({
    container: { flex: 1 },
});
export default PdfScreen;
